<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area invest02">
      <img
        :src="`${resources}img/img-top-sub-title10.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">요약재무재표</div>
        <div class="sub_txt">
          요약재무제표 재무정보를 정확하고 신속하게 제공해 드립니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="flex_box2">
        <h3>재무상태표</h3>
        <div class="txt_rht">(단위: 백만원)</div>
      </div>
      <div class="tbl_ty02 bod tbl_align_rht">
        <table>
          <caption>
            재무상태표: 구분, 2018년, 2019년,
            2020년,자산총계,유동자산,비유동자산,부채총계,유동부채,비유동부채,자본총계로
            구성
          </caption>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">2018년</th>
              <th scope="col">2019년</th>
              <th scope="col">2020년</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tbl_bg">
              <td class="td_tit">자산총계</td>
              <td>275,526</td>
              <td>275,766</td>
              <td>392,071</td>
            </tr>
            <tr>
              <td class="td_tit">유동자산</td>
              <td>71,642</td>
              <td>165,821</td>
              <td>316,679</td>
            </tr>
            <tr>
              <td class="td_tit">비유동자산</td>
              <td>203,884</td>
              <td>109,946</td>
              <td>75,391</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">부채총계</td>
              <td>135,559</td>
              <td>132,496</td>
              <td>277,580</td>
            </tr>
            <tr>
              <td class="td_tit">유동부채</td>
              <td>40,307</td>
              <td>27,951</td>
              <td>170,490</td>
            </tr>
            <tr>
              <td class="td_tit">비유동부채</td>
              <td>95,252</td>
              <td>104,544</td>
              <td>170,090</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">자본총계</td>
              <td>139,968</td>
              <td>143,270</td>
              <td>114,490</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="flex_box2"
        :class="{ mgt100: device === 'pc', mgt50: device === 'mo' }"
      >
        <h3>손익계산서</h3>
        <div class="txt_rht">(단위: 백만원)</div>
      </div>
      <div class="tbl_ty02 bod tbl_align_rht">
        <table>
          <caption>
            손익계산서: 구분, 2018년, 2019년, 2020년, 매출, 매출총이익, 영업이익
            세전이익, 순이익으로 구성
          </caption>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">2018년</th>
              <th scope="col">2019년</th>
              <th scope="col">2020년</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="td_tit">매출</td>
              <td>122,733</td>
              <td>148,990</td>
              <td>204,493</td>
            </tr>
            <tr>
              <td class="td_tit">매출총이익</td>
              <td>14,374</td>
              <td>15,570</td>
              <td>20,880</td>
            </tr>
            <tr>
              <td class="td_tit">영업이익</td>
              <td>9,941</td>
              <td>10,973</td>
              <td>12,736</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">세전이익</td>
              <td>11,021</td>
              <td>11,526</td>
              <td>-28,080</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">순이익</td>
              <td>9,562</td>
              <td>10,545</td>
              <td>19,577</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import page from '@/mixins/page';

export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
